import { SvgWrapper } from "./SvgWrapper";
import { BaseIcon } from "./types";

export const MdiArrowOutward = (props: BaseIcon) => (
  <SvgWrapper {...props}>
    <path d="M6.39072 18.3772L4.99072 16.9772L14.5907 7.37721H5.99072V5.37721H17.9907V17.3772H15.9907V8.77721L6.39072 18.3772Z" />
  </SvgWrapper>
);
